import React from 'react'
import {ViewContext} from "./viewContext";

export const useViewContext = () => React.useContext(ViewContext)